/* BUZCO: one dot per product photo on the phone gallery; the filled dot
   follows the scroll. Rebuilt whenever Dawn re-renders the gallery, because
   a custom element's connectedCallback runs on every insertion. */
if (!customElements.get('buzco-gallery-dots')) {
  customElements.define(
    'buzco-gallery-dots',
    class BuzcoGalleryDots extends HTMLElement {
      connectedCallback() {
        this.list = this.closest('slider-component')?.querySelector('.product__media-list');
        if (!this.list) return;

        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        };
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.list);
        this.build();
      }

      disconnectedCallback() {
        this.list?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
      }

      build() {
        // Only slides that are laid out (Dawn hides some variant images)
        this.slides = [...this.list.querySelectorAll('.product__media-item')].filter((slide) => slide.clientWidth > 0);
        if (this.slides.length < 2) {
          this.replaceChildren();
          return;
        }
        if (this.children.length !== this.slides.length) {
          this.replaceChildren(
            ...this.slides.map(() => {
              const dot = document.createElement('span');
              dot.className = 'buzco-gallery-dots__dot';
              return dot;
            })
          );
        }
        this.sync();
      }

      sync() {
        if (!this.slides || this.slides.length < 2) return;
        const step = this.slides[1].offsetLeft - this.slides[0].offsetLeft || this.list.clientWidth;
        const index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.list.scrollLeft / step)));
        [...this.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
    }
  );
}
